import { useQuery } from "@tanstack/react-query";
import googleBooksService from "@/features/books/services/googleBooksService";
import type { TransformedGoogleBook } from "@/features/books/types/googleBooks";

/**
 * Query hook for searching Google Books
 * @param query - Search query (title or ISBN)
 * @param searchType - Type of search: 'title' or 'isbn'
 * @param enabled - Whether the query should run (default: false, set to true when user submits search)
 */
export function useGoogleBooksSearch(query: string, searchType: "title" | "isbn", enabled = false) {
    return useQuery<TransformedGoogleBook[]>({
        enabled: enabled && query.trim().length > 0,
        queryFn: async () => {
            return await googleBooksService.searchBooks(query, searchType);
        },
        queryKey: ["googleBooks", "search", query, searchType],
        retry: 1, // Retry once on failure
        staleTime: 5 * 60 * 1000, // 5 minutes - search results don't change frequently
    });
}
